var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(-1548 -318)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 56,
    height: 56,
    transform: "translate(1548 318)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "public_FILL0_wght400_GRAD0_opsz48",
    d: "M20,36a15.58,15.58,0,0,1-6.24-1.26,15.975,15.975,0,0,1-8.5-8.5A15.58,15.58,0,0,1,4,20a15.58,15.58,0,0,1,1.26-6.24,15.975,15.975,0,0,1,8.5-8.5A15.58,15.58,0,0,1,20,4a15.58,15.58,0,0,1,6.24,1.26,15.975,15.975,0,0,1,8.5,8.5A15.58,15.58,0,0,1,36,20a15.58,15.58,0,0,1-1.26,6.24,15.975,15.975,0,0,1-8.5,8.5A15.58,15.58,0,0,1,20,36Zm-1.72-2.44V30.28a3.086,3.086,0,0,1-2.36-1.04,3.481,3.481,0,0,1-.96-2.44V25.04l-8.2-8.2a11.24,11.24,0,0,0-.28,1.58A15.476,15.476,0,0,0,6.4,20a13.39,13.39,0,0,0,3.38,9.08,12.9,12.9,0,0,0,8.5,4.48Zm11.76-4.32a13.208,13.208,0,0,0,1.54-2.04,14.254,14.254,0,0,0,1.12-2.26,12.807,12.807,0,0,0,.68-2.42A14.4,14.4,0,0,0,33.6,20,13.714,13.714,0,0,0,25.08,7.24v.72a3.481,3.481,0,0,1-.96,2.44,3.086,3.086,0,0,1-2.36,1.04H18.28v3.48a1.383,1.383,0,0,1-.54,1.12,1.88,1.88,0,0,1-1.22.44H13.2V20H23.52a1.4,1.4,0,0,1,1.12.52,1.8,1.8,0,0,1,.44,1.2V26.8H26.8a3.243,3.243,0,0,1,2.04.68A3.384,3.384,0,0,1,30.04,29.24Z",
    transform: "translate(1556 326)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLibrary);
export default __webpack_public_path__ + "static/media/HubLibrary.b11f5ecd.svg";
export { ForwardRef as ReactComponent };